import AdminEntity from "../../components/admin/AdminEntity";

export default function AdminBlogPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Blog",
      title: "Journal posts",
      testidPrefix: "admin-blog",
      singular: "post",
      addLabel: "New post",
      listEndpoint: "/admin/blog-posts",
      keyField: "slug",
      columns: [
        { key: "title", label: "Title", render: (p) => <span className="font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>{p.title}</span> },
        { key: "category", label: "Category" },
        { key: "published_at", label: "Published", render: (p) => (p.published_at || "").slice(0, 10) },
        { key: "is_draft", label: "Status", render: (p) => p.is_draft ? "Draft" : "Published" },
      ],
      createEndpoint: "/admin/blog-posts",
      updateEndpoint: (p) => `/admin/blog-posts/${p.slug}`,
      deleteEndpoint: (p) => `/admin/blog-posts/${p.slug}`,
      fields: [
        { name: "slug", label: "Slug", required: true, help: "URL fragment; must be unique" },
        { name: "title", label: "Title", required: true },
        { name: "excerpt", label: "Excerpt (meta description)", type: "textarea", rows: 3, required: true },
        { name: "hero", label: "Hero image path", required: true, help: "/images/…" },
        { name: "category", label: "Category", required: true },
        { name: "tags", label: "Tags", type: "tags", help: "Comma-separated" },
        { name: "author", label: "Author", defaultValue: "Westbridge Inn & Suites Team" },
        { name: "published_at", label: "Publish date", type: "date", required: true, help: "YYYY-MM-DD" },
        { name: "content", label: "Content (Markdown)", type: "markdown", rows: 14, required: true },
        { name: "is_draft", label: "Draft", type: "boolean", checkboxLabel: "Hide from public" },
      ],
    }} />
  );
}
